import {
  apiAddInvoice,
  apiDeleteInvoice,
  apiGetInvoices,
  apiUpdateInvoice,
} from "@lib/api/billing";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useInvoiceQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "invoice",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const invoicesQuery = useQuery({
    queryFn: () => apiGetInvoices(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addInvoiceMutation = useMutation({
    mutationFn: apiAddInvoice,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.invoice"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateInvoiceMutation = useMutation({
    mutationFn: apiUpdateInvoice,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.invoice"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteInvoiceMutation = useMutation({
    mutationFn: apiDeleteInvoice,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.invoice"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    invoicesQuery,
    addInvoiceMutation,
    updateInvoiceMutation,
    deleteInvoiceMutation,
  };
};
